import styled from '@emotion/styled'
import AppleLogo from 'assets/icons/apple-icon.svg'
import GoogleLogo from 'assets/icons/google-icon.svg'
import { NewFlexContainer } from 'components/common/common.style'

export const FullWidth = styled.div`
  width: 100%;
`

export const SsoButtons = styled(FullWidth)`
  display: flex;
  justify-content: center;
  gap: 15px;
`

export const StyledAppleLogo = styled(AppleLogo)`
  width: 15px;
  height: 15px;
`

export const StyledGoogleLogo = styled(GoogleLogo)`
  width: 15px;
  height: 15px;
`

export const SponsorContainer = styled(NewFlexContainer)`
  position: relative;
`
